import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@tanstack/react-query'
import { useHistory } from 'react-router-dom'
import { useToast } from '@hub-la/shadcn'
import { QueryKey } from '../../domain/enums/query-key'
import { DeleteProduct } from '../../usecases/delete-product'
import { GetDashboardUrl } from '../../usecases/get-dashboard-url'

export const useDeleteProduct = () => {
  const container = useContainer()
  const history = useHistory()
  const { toast } = useToast()
  const { t } = useTranslation()

  return useMutation(
    [QueryKey.toggleProductVisibility],
    (productId: string) => new DeleteProduct(container.get(HttpClient)).execute(productId),
    {
      retry: false,
      onSuccess: () => {
        history.push(new GetDashboardUrl().execute())
      },
      onError: (error: Error) => {
        toast({
          title: 'Error',
          description: t(error.message),
          variant: 'destructive',
        })
      },
    },
  )
}
